const Theme = {
  token: {
    colorPrimary: "#ff39b3",
    borderRadius: 6,
  },
  components: {
    Form: {
      labelFontSize: 13,
      verticalLabelMargin: 2,
      verticalLabelPadding: 0,
      itemMarginBottom: 10,
    },
    Button: {
      fontSizeLG: 14,
    },
  },
};

export default Theme;
